import { render, staticRenderFns } from "./PayOrderDetail.vue?vue&type=template&id=5066f7e0&scoped=true&"
import script from "./PayOrderDetail.vue?vue&type=script&lang=js&"
export * from "./PayOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./PayOrderDetail.vue?vue&type=style&index=0&id=5066f7e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5066f7e0",
  null
  
)

export default component.exports